var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', {
    staticClass: "discovery-card",
    "class": "discovery-card--".concat(_vm.content.tone)
  }, [_c('div', {
    staticClass: "discovery-card__copy"
  }, [_c('h3', [_vm._v(_vm._s(_vm.copy[0]))]), _c('p', [_vm._v(_vm._s(_vm.copy[1]))])]), _c('DiscoveryIllustration', {
    attrs: {
      "scene": _vm.content.scene
    }
  }), _c('div', {
    staticClass: "discovery-card__footer"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "small": "",
      "color": "primary",
      "to": _vm.sectionName ? {
        name: _vm.sectionName
      } : undefined,
      "loading": _vm.loading,
      "disabled": _vm.disabled,
      "aria-label": _vm.actionLabel || _vm.copy[2]
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('choose');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.copy[2]) + " "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("mdi-arrow-right")])], 1), _vm._t("secondary-action")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }